<template>
    <div class="e2Warp">
        <versionNav></versionNav>
        <div style="height:106px;width:100%"></div>
        <freeProps></freeProps>
    </div>
</template>
<script>
import freeProps from '../components/freeProps.vue'
export default {
    name:'e2',
    components:{
        freeProps
    }
}
</script>
<style lang="scss" scoped>
.e2Warp {
    background: url("//cdn1.zygames.com/qqsm/Public/img/version/bg6.jpg") no-repeat top center;
}
 .topEmpty{
    //  padding-top: 106px;
     width: 100%;
 }
</style>



// WEBPACK FOOTER //
// src/pages/e2.vue